import { useMemo } from 'react';

import adminOrderTemplateService from '@services/admin/orderTemplateService';

/**
 * Admin Order Template Service Hook
 *
 * Simple wrapper for adminOrderTemplateService, maintaining consistency with operator hook
 *
 * @example
 * const orderTemplateService = useAdminOrderTemplateService();
 *
 * await orderTemplateService.create({ name: 'Template A', content: '...' });
 * await orderTemplateService.getById(1);
 */
export function useAdminOrderTemplateService() {
  return useMemo(() => adminOrderTemplateService, []);
}
